// booths.js — the named stations, so a booth code is TAPPED, not typed.
//
// A booth code ties three things together: the shift opened with it, the OBS
// browser-source URLs carrying `?s=CODE`, and the code shown on that booth's
// screen for guests. A typo in any of them is silent until a pancake lands at
// the wrong venue — and the shift-open field is sticky per device, so a typo
// made once persists until somebody notices. Presets remove the typing.
//
// WHY STATIONS AND NOT PEOPLE (Dan, 2026-09-25): a station is a rig, not a
// person. Wella may work Dan's event, hired artists rotate, and a code reading
// "WELA" on someone else's booth is worse than a neutral one — it asserts
// something false. Stations are positional and say nothing that can go stale.
//
// WHY LETTERS AND NOT "Station 1/2": the code doubles as something a guest may
// type off a booth screen, so the alphabet excludes digits along with I and O
// (see CODE_ALPHABET in utils/shiftScope) — 0/O and 1/I are the classic
// misreads. Station A/B keeps the spoken shorthand ("you're on B") without
// giving guests a character they can get wrong.
//
// Free text still works everywhere these are offered: a one-off third rig
// shouldn't need a deploy. Add regulars here so they get a chip.
//
// Scale path, when hired artists make this a chore: move the list to a
// `config/booths` doc with an editor in Admin. Everything reads it through
// BOOTH_PRESETS, so only this file changes.
export const BOOTH_PRESETS = [
  { code: "STNA", label: "Station A" },
  { code: "STNB", label: "Station B" },
  { code: "STNC", label: "Station C" },
  { code: "STND", label: "Station D" },
];

// The house station. An OBS browser source with a BARE url (no `?s=`) is
// saying "I'm the usual rig" — so when two events are live and nothing else
// resolves it, it lands here instead of going to the diagnostic. That keeps
// Dan's existing scene collection working untouched while a second rig, which
// IS scoped, stays strict.
//
// Deliberately narrow: this is a last resort, applied only by overlay
// surfaces (useCurrentShiftOrders, UnscopedScreenBadge). Staff screens still
// show the picker rather than guessing, and guests still choose their booth —
// a wrong guess there costs someone a pancake, whereas a wrong guess on an
// overlay is visible on a screen the operator is standing next to.
export const DEFAULT_BOOTH_CODE = "STNA";

// Codes compare uppercase everywhere (normalizeJoinCode strips the rest).
export function presetLabelFor(code) {
  if (!code) return null;
  const hit = BOOTH_PRESETS.find(b => b.code === String(code).toUpperCase());
  return hit ? hit.label : null;
}
